// extracted by mini-css-extract-plugin
export var formContainer = "_l8-0";
export var message = "_l8-1";